import FreemiumEventCreatePhoneVerificationStep from './FreemiumEventCreatePhoneVerificationStep';

export default FreemiumEventCreatePhoneVerificationStep;
